import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken, getUserByTokenReal } from "../../crud/auth.crud";
import { getOneDB } from "../../crud/api";
import { getImageURL, hosts } from "../../pages/home/utils";
import * as routerHelpers from "../../router/RouterHelpers";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  Register: "[Register] Action",
  UserRequested: "[Request User] Action",
  UserLoaded: "[Load User] Auth API",
  UserPicUpdated: "[Update User] Action"
};

const initialAuthState = {
  user: undefined,
  authToken: undefined
};

export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname;

export const reducer = persistReducer(
    { storage, key: "demo1-auth", whitelist: ["user", "authToken"] },
    (state = initialAuthState, action) => {
      switch (action.type) {
        case actionTypes.Login: {
          const { authToken } = action.payload;

          return { authToken, user: undefined };
        }

        case actionTypes.Register: {
          const { authToken } = action.payload;

          return { authToken, user: undefined };
        }

        case actionTypes.Logout: {
          routerHelpers.forgotLastLocation();
          localStorage.removeItem('accessToken');
          return initialAuthState;
        }

        case actionTypes.UserLoaded: {
          const { user } = action.payload;

          return { ...state, user };
        }

        case actionTypes.UserPicUpdated: {
          const { pic } = action.payload;
          const { user = {} } = state;

          return { ...state, user: { ...user, pic } };
        }

        default:
          return state;
      }
    }
);

export const actions = {
  login: authToken => ({ type: actionTypes.Login, payload: { authToken } }),
  register: authToken => ({
    type: actionTypes.Register,
    payload: { authToken }
  }),
  logout: () => ({ type: actionTypes.Logout }),
  requestUser: user => ({ type: actionTypes.UserRequested, payload: { user } }),
  fulfillUser: user => ({ type: actionTypes.UserLoaded, payload: { user } }),
  updateUserPic: pic => ({ type: actionTypes.UserPicUpdated, payload: { pic } })
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser());
  });

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    try {
      const tokenResponse = yield getUserByTokenReal({ token: localStorage.getItem('accessToken') });
      const tokenData = yield tokenResponse.json();

      if (!tokenData || !tokenData.id) {
        return;
      }

      const userResponse = yield getOneDB('user/', tokenData.id);
      const userData = yield userResponse.json();

      if (!userData || !userData.response) {
        return;
      }

      const {
        name,
        lastName,
        email,
        _id: id,
        fileExt,
        profilePermissions = {},
        selectedBoss = {},
        selectedUserProfile = null
      } = userData.response;

      const pic = (fileExt ? getImageURL(id, 'user', fileExt) : `${window.location.origin}/media/misc/placeholder-image.jpg`);

      const accessToken = localStorage.getItem('accessToken') || '';

      const user = {
        id,
        name,
        lastName,
        email,
        fullname: `${name} ${lastName}`,
        pic,
        profilePermissions,
        selectedBoss: selectedBoss,
        selectedUserProfile: selectedUserProfile,
        accessToken: accessToken,
        boss: selectedBoss
      };

      yield put(actions.fulfillUser(user));
    } catch (error) {
      console.error('Error loading user:', error);
    }
  });
}
